import { Routes, Route, Navigate } from "react-router-dom";
import appInfo from "./app-info";
import routes from "./app-routes";
import { SideNavInnerToolbar as SideNavBarLayout } from "./layouts";
import { Footer } from "./components";
import { useAuth } from "./contexts/auth";

export default function Content() {
  const { user } = useAuth();

  //Fetch Initial Pages on Login Successful Render :
  const roleRedirectMap = {
    company: "/adminDashboard",
    companyuser: "/developerDashboard",
    customer: "/customerDashboard",
    customerContact: "/custContactDash",
  };

  const redirectPath = roleRedirectMap[user?.userrole] || "/ticket";
  return (
    <SideNavBarLayout title={appInfo.title}>
      <Routes>
        {routes.map(({ path, element }) => (
          <Route key={path} path={path} element={element} />
        ))}
        <Route path="*" element={<Navigate to={redirectPath} />} />
      </Routes>
      <Footer>
        Copyright © {new Date().getFullYear()}-{new Date().getFullYear() + 1}{" "}
        Quantum IT Solution.
      </Footer>
    </SideNavBarLayout>
  );
}
